import { useCallback, useEffect, useMemo, useState } from 'react';
import http from 'hub-http/clients/apiClient';
import ContentRoutes from 'ContentUtils/Routes';
import TemplateTypes from 'ContentUtils/constants/TemplateTypes';
import DesignAssetTypes from 'ContentUtils/constants/DesignAssetTypes';
import { ContentObjectTypes, RequestStatuses } from 'content-management-data-lib';
const LayoutLinkType = 'Layout';
const getUrl = (data, assetId, assetType) => {
  const {
    assetSource,
    builtIn,
    linkType,
    href,
    path
  } = data;
  let correctedAssetId = assetId;
  let correctAssetType = assetType;
  if (assetId === undefined) {
    correctedAssetId = builtIn ? href : data.id;
  }
  if (assetType === undefined) {
    correctAssetType = linkType === LayoutLinkType ? DesignAssetTypes.LAYOUT : DesignAssetTypes.TEMPLATE;
  }
  return ContentRoutes.designManager(correctedAssetId, correctAssetType, assetSource, path);
};
const getUrlFromResponseData = (contentObjectType, data) => {
  if (contentObjectType === ContentObjectTypes.BLOG_POST) {
    let assetId;
    let assetType;
    const {
      body,
      id,
      layoutData
    } = data;
    if (layoutData) {
      assetId = id;
      assetType = DesignAssetTypes.LAYOUT;
    } else if (body && body.generatedFromLayoutId) {
      assetId = body.generatedFromLayoutId;
      assetType = DesignAssetTypes.LAYOUT;
    }
    return getUrl(data, assetId, assetType);
  }
  return getUrl(data);
};
const getRequestUrl = (contentObjectType, layoutId, templatePath) => contentObjectType === ContentObjectTypes.BLOG_POST && layoutId ? `designmanager/v1/layouts/unified/${layoutId}` : `designmanager/v1/templates/by-path/${templatePath}`;
const useFetchTemplateForContent = ({
  contentObjectType,
  layoutId,
  templatePath
}) => {
  const [template, setTemplate] = useState(null);
  const [requestStatus, setRequestStatus] = useState(RequestStatuses.UNINITIALIZED);
  const fetchRequest = useCallback(() => {
    setRequestStatus(RequestStatuses.PENDING);
    http.get(getRequestUrl(contentObjectType, layoutId, templatePath)).then(response => {
      const formattedTemplate = {
        label: response.displayName || response.label,
        isStarterTemplate: response.templateType === TemplateTypes.byName.simple_landing_page_template.id,
        url: getUrlFromResponseData(contentObjectType, response)
      };
      setTemplate(formattedTemplate);
      setRequestStatus(RequestStatuses.SUCCEEDED);
    }).catch(() => {
      setRequestStatus(RequestStatuses.FAILED);
    });
  }, [contentObjectType, layoutId, templatePath]);
  useEffect(() => {
    if (templatePath || layoutId) {
      fetchRequest();
    }
  }, [fetchRequest, templatePath, layoutId]);
  return useMemo(() => ({
    template,
    requestStatus
  }), [requestStatus, template]);
};
export default useFetchTemplateForContent;